import { useEffect, useState } from "react";
import api, { LOGO_URL } from "@/lib/api";
import { SITE_URL, orgSchema } from "@/lib/seo";

const clearStaticHead = () => document.head.querySelectorAll("[data-static-seo]").forEach((n) => n.remove());

let seoConfigPromise = null;
const loadSeoConfig = () => {
  if (!seoConfigPromise) seoConfigPromise = api.get("/seo/config").then((r) => r.data).catch(() => ({}));
  return seoConfigPromise;
};

export const Seo = ({ title, description, path = "/", image = LOGO_URL, type = "website", jsonLd = [], noindex = false }) => {
  const [cfg, setCfg] = useState({});
  const url = `${SITE_URL}${path}`;
  const list = [orgSchema(cfg.same_as || []), ...(Array.isArray(jsonLd) ? jsonLd : [jsonLd])];
  useEffect(clearStaticHead, []);
  useEffect(() => { loadSeoConfig().then(setCfg); }, []);
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
      <link rel="canonical" href={url} />
      {cfg.google_verification && <meta name="google-site-verification" content={cfg.google_verification} />}
      {cfg.bing_verification && <meta name="msvalidate.01" content={cfg.bing_verification} />}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Ember & Steel Studio" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_CA" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {list.map((obj, i) => (
        <script key={`${path}-${i}`} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(obj) }} />
      ))}
    </>
  );
};
